import { Copy } from "lucide-react";
import { showErrorToast, showSuccessToast } from "./Toast.js";
import { Button, type ButtonProps } from "./Button.js";

type ItemText = { text: string };

/** Copies one item group in the same newline-delimited format accepted by import paste. */
export function CopyItemsButton({
  items,
  variant = "secondary",
  className,
}: {
  items: readonly ItemText[];
  variant?: ButtonProps["variant"];
  className?: string;
}) {
  const text = items
    .map((item) => item.text.trim())
    .filter(Boolean)
    .join("\n");
  const itemCount = text ? text.split("\n").length : 0;

  async function copyItems() {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      showSuccessToast(
        `Copied ${itemCount} item${itemCount === 1 ? "" : "s"} to the clipboard.`
      );
    } catch {
      showErrorToast("Could not copy the items. Please try again.");
    }
  }

  const title = "Copy items to clipboard";

  return (
    <Button
      type="button"
      variant={variant}
      size="icon-sm"
      className={className}
      disabled={!text}
      title={title}
      aria-label={title}
      onClick={() => void copyItems()}
      icon={<Copy size={18} aria-hidden="true" />}
    />
  );
}
